// Shared responsive-view policy. Keeping the breakpoint and resolution logic in
// one pure module prevents the app and QA harness from independently hardcoding
// what should happen at a given viewport width.

export const NARROW_MAX_WIDTH = 700;
export const NARROW_QUERY = `(max-width: ${NARROW_MAX_WIDTH}px)`;

export function effectiveViewFor(view, isNarrow) {
  return isNarrow && view === 'sxs' ? 'unified' : view;
}

// CSV/TSV desktop presentation has an inclusive 700px boundary of its own.
export const RECORD_TABLE_QUERY = '(min-width: 700px)';
export function recordLayoutFor(format, view, desktop) {
  return desktop && view === 'sxs' && ['csv', 'tsv', 'parquet'].includes(format) ? 'table' : 'legacy';
}

// Which record renders mount a real `<table class="record-table">`: the desktop
// Side-by-side table layout (REL-052) AND Unified at every width, which has been
// a table since the same change. `renderRecords` is driven by this predicate and
// the QA contract asserts against it, so the two cannot describe different
// policies — they did, and the QA suite failed at every narrow viewport for a
// renderer that was behaving correctly (REL-063).
export function recordsUseTable(effectiveView, layout) {
  if (effectiveView === 'unified') return true;
  return effectiveView === 'sxs' && layout === 'table';
}

// The standalone Parquet workbench (/parquet-viewer, once a dataset is open)
// collapses its column sidebar at the same width the app's nav collapses, so a
// phone gets the whole viewport for rows. One statement of the rule; the view
// and its tests both read it from here (G50).
export const SIDEBAR_MAX_WIDTH = 860;
